import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

export const PageNotFound = () => <div className='page-not-found'>
	<span className='code'>404</span>
	<div className='page'>Страница не найдена</div>
	<Link to='/' className='link'>Назад на главную</Link>
</div>